import { PaginationActionProps } from 'common/state/types';

// #region ClientTransfer
export enum ClientTransferStatuses {
  ACCEPTED = 'accepted',
  UNACCEPTED = 'unaccepted',
  REQUESTED = 'requested',
  SENT = 'sent',
}

export interface ClientTransfer {
  url: string;
  id: number;
  description: string;
  sender: string;
  request: string;
  destination: string;
  registrar: string;
  reference: string;
  bank_reference: string;
  currency: string;
  amount: string;
  date: string;
  bank_date: string;
  status: ClientTransferStatuses;
  got_currency: string;
  got_amount: string;
}

export interface NewClientTransferStarted {
  type: 'clients/transfers/new/started';
}

export interface NewClientTransferFinished {
  type: 'clients/transfers/new/finished';
  success: boolean;
  error?: string;
}

export type NewClientTransferActions =
  | NewClientTransferStarted
  | NewClientTransferFinished;

export interface AcceptClientTransferStarted {
  type: 'clients/transfers/accept/started';
}

export interface AcceptClientTransferFinished {
  type: 'clients/transfers/accept/finished';
  success: boolean;
  error?: string;
}

export type AcceptClientTransferActions =
  | AcceptClientTransferStarted
  | AcceptClientTransferFinished;

export interface UnacceptClientTransferStarted {
  type: 'clients/transfers/unaccept/started';
}

export interface UnacceptClientTransferFinished {
  type: 'clients/transfers/unaccept/finished';
  success: boolean;
  error?: string;
}

export type UnacceptClientTransferActions =
  | UnacceptClientTransferStarted
  | UnacceptClientTransferFinished;

interface ClientIncomingTransfersStarted {
  type: 'clients/transfers/incoming/started';
}

interface ClientIncomingTransfersFinished extends PaginationActionProps {
  type: 'clients/transfers/incoming/finished';
  transfers?: ClientTransfer[];
  error?: string;
}

export type ClientIncomingTransfersActions =
  | ClientIncomingTransfersStarted
  | ClientIncomingTransfersFinished;

interface UserIncomingTransfersStarted {
  type: 'contacts/transfers/incoming/started';
}

interface UserIncomingTransfersFinished extends PaginationActionProps {
  type: 'contacts/transfers/incoming/finished';
  transfers?: ClientTransfer[];
  error?: string;
}

export type UserIncomingTransfersActions =
  | UserIncomingTransfersStarted
  | UserIncomingTransfersFinished;

interface ClientOutgoingTransfersStarted {
  type: 'clients/transfers/outgoing/started';
}

interface ClientOutgoingTransfersFinished extends PaginationActionProps {
  type: 'clients/transfers/outgoing/finished';
  transfers?: ClientTransfer[];
  error?: string;
}

export type ClientOutgoingTransfersActions =
  | ClientOutgoingTransfersStarted
  | ClientOutgoingTransfersFinished;

interface UserOutgoingTransfersStarted {
  type: 'contacts/transfers/outgoing/started';
}

interface UserOutgoingTransfersFinished extends PaginationActionProps {
  type: 'contacts/transfers/outgoing/finished';
  transfers?: ClientTransfer[];
  error?: string;
}

export type UserOutgoingTransfersActions =
  | UserOutgoingTransfersStarted
  | UserOutgoingTransfersFinished;
// #endregion

// #region ClientTransferRequest
export enum ClientTransferRequestStatuses {
  OPEN = 'open',
  COMPLETED = 'completed',
  CANCELLED = 'canceled',
}

export interface ClientTransferRequest {
  url: string;
  id: number;
  description: string;
  reference: string;
  requester: string;
  sender: string;
  receiver: string;
  currency: string;
  amount: string;
  date: string;
  status: ClientTransferRequestStatuses;
  transfers: string[];
}

export interface NewClientTransferRequestStarted {
  type: 'clients/transfer_requests/new/started';
}

export interface NewClientTransferRequestFinished {
  type: 'clients/transfer_requests/new/finished';
  success: boolean;
  error?: string;
}

export type NewClientTransferRequestActions =
  | NewClientTransferRequestStarted
  | NewClientTransferRequestFinished;

export interface CompleteClientTransferRequestStarted {
  type: 'clients/transfer_requests/complete/started';
}

export interface CompleteClientTransferRequestFinished {
  type: 'clients/transfer_requests/complete/finished';
  success: boolean;
  error?: string;
}

export type CompleteClientTransferRequestActions =
  | CompleteClientTransferRequestStarted
  | CompleteClientTransferRequestFinished;

export interface CancelClientTransferRequestStarted {
  type: 'clients/transfer_requests/cancel/started';
}

export interface CancelClientTransferRequestFinished {
  type: 'clients/transfer_requests/cancel/finished';
  success: boolean;
  error?: string;
}

export type CancelClientTransferRequestActions =
  | CancelClientTransferRequestStarted
  | CancelClientTransferRequestFinished;

interface ClientTransferRequestsStarted {
  type: 'clients/transfer_requests/started';
}

interface ClientTransferRequestsFinished extends PaginationActionProps {
  type: 'clients/transfer_requests/finished';
  requests?: ClientTransferRequest[];
  error?: string;
}

export type ClientTransferRequestsActions =
  | ClientTransferRequestsStarted
  | ClientTransferRequestsFinished;
// #endregion
